import { RootState } from '@reducers';

export const selectCorporateHealthPolicyClaim = (state: RootState) =>
  state.userDashboardRouteReducer.policyClaim.corporateHealthPolicyClaim;
